import { render, staticRenderFns } from "./generalPage.vue?vue&type=template&id=178479ca"
import script from "./generalPage.vue?vue&type=script&lang=js"
export * from "./generalPage.vue?vue&type=script&lang=js"
import style0 from "./generalPage.vue?vue&type=style&index=0&id=178479ca&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports